import React from 'react';
import FloatingShapes from "../common/FloatingShapes";

const timeSchedule = [
  {
    category: "Хөгжлийн хөтөлбөр",
    items: [
      {
        title: "Өглөөний хөтөлбөр",
        desc: "Ихэвчлэн нийт амрагчдыг хамарсан бүлгэмийн хэмжээнд, хүүхэд хөгжлийн ордон болон гадаа орчинд түшиглэсэн, мэргэжлийн хөтөлбөр удирдагчид, багш нарын хамтарсан багийн удирдлагаар зохион байгуулагдах хөтөлбөрүүд явагдана.",
        perDay: "3 цаг",
      },
      {
        title: "Үдээс хойшхи хөтөлбөр",
        desc: "Ихэвчлэн бүлгийн болон 2-3 бүлэг дундын хүрээнд бүлгийн ажил хэлбэрээр, бүлэг удирдсан багшийн удирдлагаар зохион байгуулагдана.",
        perDay: "1 цаг 30 минут",
      },
      {
        title: "Оройн хөтөлбөр",
        desc: "Ихэвчлэн хөгжөөнт, цэнгээнт, энтертаймент шоу хэлбэрийн хөтөлбөрүүд байна.",
        perDay: "1 цаг 30 минут",
      },
    ],
    perDayTotal: "6 цаг",
    weekTotal: "36-40 цаг",
  },
  {
    category: "Хооллох",
    items: [
      {
        title: "Хоол, цай",
        desc: "3 удаагийн хоол, 1 удаагийн хөнгөн цай, оройн сүү тараг (5 удаагийн давтамжтай хоол, цай).",
        perDay: "5 цаг",
      },
    ],
    perDayTotal: "5 цаг",
    weekTotal: "35 цаг",
  },
  {
    category: "Өөртөө үйлчлэх, чөлөөт цаг",
    items: [
      {
        title: "Хувийн бэлтгэл",
        desc: "Хөтөлбөр хоорондын болон хооллох амрах цагийн өмнө хувийн бэлтгэл хийх, хувцас солих, ариун цэвэр сахих гэх мэт.",
        perDay: "5 цаг",
      },
    ],
    perDayTotal: "5 цаг",
    weekTotal: "35 цаг",
  },
];

const day1Bigday = [
  {
    age: "Бага нас (6-10)",
    winter: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр - зуслангийн дүрэм, амрагчийн дэг, аюулгүй байдлын зааварчилгаа танилцуулах"],
    spring: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр - зуслангийн дүрэм, амрагчийн дэг, аюулгүй байдлын зааварчилгаа танилцуулах"],
    goal: "Дасан зохицох, орчинтой танилцах, амралтын дэгээ мэдэх",
  },
  {
    age: "Дунд нас (11-14)",
    winter: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр - зуслангийн дүрэм, амрагчийн дэг, аюулгүй байдлын зааварчилгаа танилцуулах"],
    spring: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр", "Багийн нөхөрсөн уур амьсгал бүрдүүлэх", "Багийн гишүүдтэйгээ танилцах"],
    goal: "Дасан зохицох, орчинтой танилцах, амралтын дэгээ мэдэх",
  },
  {
    age: "Ахлах нас (15-18)",
    winter: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр - зуслангийн дүрэм, амрагчийн дэг, аюулгүй байдлын зааварчилгаа танилцуулах"],
    spring: ["Хүлээн авах, бүлэг өрөө зохион байгуулалт", "Өргөө гэр Найрамдал хөтөлбөр", "Итгэлцэл бий болгох, өөрсдийгөө найз нөхдөдөө эерэг зөв ойлгуулах", "Хувийн манлайлал ур чадвараа богино хугацаанд танилцуулах"],
    goal: "Дасан зохицох, орчинтой танилцах, амралтын дэгээ мэдэх",
  },
];

const day1Smallday = [
  {
    age: "Бага нас (6-10)",
    winter: ["Нэг бүлэг - Нэг баг бүлгийн ажил"],
    spring: ["Нэг бүлэг - Нэг баг бүлгийн ажил"],
    goal: "Багийн гишүүдтэйгээ танилцах, бүлгийн зорилго, амралтын үеийн дүрмээ гаргах, бусдыг гомдоохгүйгээр амрах аргад суралцах",
  },
  {
    age: "Дунд нас (11-14)",
    winter: ["Би ба бид бүлгийн ажил", "Icebreaker + баг бүрдүүлэх", "Outdoor team game"],
    spring: ["Баг-бүлгийн дүрмээ зохиох", "Бүлэгт харилцаа хандлагын зөрчилгүй байхад суралцах"],
    goal: "Багийн ажиллагаанд суралцах",
  },
  {
    age: "Ахлах нас (15-18)",
    winter: ["Fitness challenge", "Би хэн бэ - өөрийгөө таниулах", "Манлайллын дасгал", "Challenge game"],
    spring: ["Хэн нь хэн бэ гэдгийг мэдэх", "Дээрэлхэлт ялгаварлалгүй амрах сэтгэгдэл төлөвшүүлэх"],
    goal: "Манлайлалаа харуулах",
  },
];

const projectPrograms = [
  {
    age: "Бага нас (6-10)",
    items: [
      "Шүрэн урлал - шүрээр бүтээл хийхэд суралцана",
      "Уран зураг - өнгөний хувиргалтууд, шинэ өнгө гаргах аргууд, зураг зурах анхны техникт суралцана",
      "Уяа зангилаа - уяа зангилааны олон аргуудад суралцана",
      "Дуу, үндэсний бүжиг, бөмбөр гэх мэт урлагийн хөтөлбөрүүд",
      "Үкүлэлэ, калимба хөгжмийн хөтөлбөр - хөгжмийн шинэ зэмсгүүдтэй танилцаж 2-3 дуу тоглож сурна",
      "Лего ровот - өөрийн хүссэн загварын ровотыг бүтээх",
    ],
  },
  {
    age: "Дунд нас (11-14)",
    items: [
      "Шүрэн урлал, уран зураг, дуу бүжиг хөгжмийн хөтөлбөрүүдэд хамрагдах",
      "Спорт өрөлт - 3х3, 6х6, 9х9 өрөлтийн техникүүдэд суралцана",
      "Ширээний теннис, гар бөмбөг, сагсан бөмбөг, хөл бөмбөг, шатар, даамны хөтөлбөрүүд",
      "Анхны тусламж үзүүлж сурах",
      "Үндэсний өв уламжлал, тоглоом наадгайн хөтөлбөр, гэр барих аргад сурах",
      "Лего ровот - өөрийн хүссэн загварын ровотыг бүтээх, жижиг програм зохиож хөдөлгөөнд оруулах",
    ],
  },
  {
    age: "Ахлах нас (15-18)",
    items: [
      "Спортын төсөлт хөтөлбөрүүд, дуу бүжгийн хөтөлбөрүүд",
      "Уулын дугуйн, ханан хадны гэх мэт эр зоригийн хөтөлбөрүүд",
      "VR контент үзэх",
      "Үндэсний спорт, монгол гэр барих, буулгах аргад суралцах хөтөлбөр",
    ],
  },
];

const entertainmentPrograms = [
  {
    title: "Тоглоомын тойрог",
    desc: "ОУХНЦ-ын хөтөлбөрийн санд байгаа гадна болон дотор орчинд тоглох тоглоомууд, улирал цаг агаарын онцлогт тохирсон тоглоомууд, баг хамт олноор тоглох тоглоомууд гэсэн ангилал төрөл бүхий, бага насны хүүхдэд тохирох 140 орчим тоглоомуудаас бүлгийн онцлогт тохируулан, өртөөчилсөн хэлбэрээр зохион байгуулж нэг удаагийн хөтөлбөрөөр 8-10 тоглоом тоглоно.",
    goal: "Тоглонгоо хамтач зан чанарт суралцах, багийн гишүүний үүрэг хувь нэмрийг ойлгох, зөөлөн ур чадварт суралцах болно.",
  },
  {
    title: "Байгалийн аялал",
    desc: "Ойн аялал хийх, аялах явцдаа амьтадын тухай сонирхолтой зүйлүүд, шоргоолжны үүрийн бүтэц, зохион байгуулалтын тухай мэдлэг олгох, харанхуй өртөө, аалзны өртөө, дүүжин гүүр зэрэг адал явдлын өртөөгөөр аялах болно.",
    goal: "Амьдрах ухаан, бие даах ур чадварт суралцах, асуудал шийдвэрлэх, эрсдлийг үнэлж зөв шийдвэр гаргах ур чадварт суралцана.",
  },
  {
    title: "Хээрийн аялал",
    desc: "Хээрийн нөхцөлд өөрсдийн байр оромж бэлтгэх, хоол бэлтгэх, эрсдэл учирсан үед зүг чиг олох, байгалиас ус гаргах, анхны тусламж үзүүлэх ур чадваруудад суралцана.",
    goal: "Бие даах ур чадварыг хөгжүүлэх",
  },
  {
    title: "Бүлгийн ажлууд",
    desc: "Хандлагаа өөрчилье, Найзаа хайрлая, Муу нөхрийн шинж, Танихгүй танил, Том халаас, Шударга ёсонд суралцья гэх мэт хөтөлбөрийн санд байгаа 50 гаруй төрлийн бүлгийн ажил, өртөөчилсөн хөтөлбөрүүд, бүлгийн ажлуудаар дамжуулан ёс зүйт хариуцлагатай иргэн байх, багаар ажиллах, хамтач байх арга зүйд суралцах, дээрэлхэлт гадуурхалтыг жигших зан төлөвт суралцах аргуудыг мэддэг болно.",
    goal: "Нийгэмших ур чадваруудаа сайжруулна.",
  },
];

const eveningPrograms = [
  {
    age: "Бага нас (6-10)",
    items: [
      "Тоглоомт дасгал",
      "Шинэ дуу бүжиг сурах",
      "Оюун ухаан сэтгэхүй хөгжүүлэх тоглоомууд",
      "Багаар тоглох тоглоомууд",
      "Тойрон бүжгийн баяр",
    ],
    goal: "Сонирхол",
  },
  {
    age: "Дунд нас (11-14)",
    items: [
      "STEAM тоглоомууд",
      "Танин мэдэхүйн тоглоомууд",
      "Бүлгийн ажлууд",
      "Галын наадам",
      "Түүдгийн дэргэдэх ярилцлага",
      "Бүлэг дундын уулзалт",
      "Хорол, шагайн наадгайнууд",
      "Оньсон болон хөлөгт тоглоомууд",
      "Үндэсний тоглоомын үдэш",
      "Хаппи тайм хөгжөөнт хөтөлбөр",
    ],
    goal: "Логик",
  },
  {
    age: "Ахлах нас (15-18)",
    items: [
      "Хөтөлбөрт диско",
      "Дэвжээ, АХА тэмцээн, хэлэлцүүлэг",
      "Спортын болон урлагийн хөтөлбөрүүд",
      "Фанатуудын үдэш, кино үдэш",
      "Дүрд хувирах маскарад шоу",
      "Найрамдлын одод шоу тоглолт",
      "Галын наадам",
      "Түүдгийн дэргэд",
    ],
    goal: "Шийдэл",
  },
];

const SevenDayProgram = () => {
  return (
    <>
      {/* Hero */}
      <section className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
        </div>
        <FloatingShapes variant="default" />
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />

        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-24">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-primary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              Бүтээгдэхүүн, үйлчилгээ
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-6">
              <span className="bg-gradient-to-r from-primary-400 via-secondary-400 to-primary-300 bg-clip-text text-transparent">
                7 хоногийн хөтөлбөр
              </span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">
              ОЛОН УЛСЫН ХҮҮХДИЙН НАЙРАМДАЛ ЦОГЦОЛБОРЫН 7 ӨДРИЙН ҮЛГЭРЧИЛСЭН ХӨТӨЛБӨР
            </p>
          </div>
        </div>
      </section>

      {/* Time Allocation */}
      <section className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-6xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4">Нэг өдрийн амралтын цагийн хуваарилалт</h2>
            <p className="text-neutral-500">Нийт амрагчтай ажиллах цаг 07.00-23.00 буюу 16 цаг</p>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500 mt-4" />
          </div>

          <div className="space-y-6">
            {timeSchedule.map((cat, idx) => (
              <div key={idx} className="rounded-2xl border border-neutral-200 overflow-hidden shadow-sm">
                <div className="bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-4 flex items-center justify-between flex-wrap gap-2">
                  <h3 className="text-lg font-bold text-white">{cat.category}</h3>
                  <div className="flex items-center gap-3 text-sm">
                    <span className="bg-white/20 px-3 py-1 rounded-full text-white font-semibold">Өдөрт: {cat.perDayTotal}</span>
                    <span className="bg-white/20 px-3 py-1 rounded-full text-white font-semibold">7 хоногт: {cat.weekTotal}</span>
                  </div>
                </div>
                <div className="divide-y divide-neutral-100">
                  {cat.items.map((item, i) => (
                    <div key={i} className="p-5 hover:bg-neutral-50 transition-colors">
                      <div className="flex items-start justify-between gap-4 flex-wrap">
                        <div className="flex-1 min-w-0">
                          <h4 className="font-bold text-neutral-900 mb-1">{item.title}</h4>
                          <p className="text-sm text-neutral-600 leading-relaxed">{item.desc}</p>
                        </div>
                        <span className="flex-shrink-0 bg-primary-50 text-primary-700 text-sm font-semibold px-3 py-1.5 rounded-lg">{item.perDay}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Total */}
            <div className="rounded-2xl bg-gradient-to-r from-primary-700 to-secondary-600 p-6 text-white text-center">
              <p className="text-sm font-semibold uppercase tracking-wider opacity-80 mb-2">Нийт</p>
              <p className="text-3xl font-extrabold">16 цаг / өдөр  ·  112 цаг / 7 хоног</p>
            </div>
          </div>
        </div>
      </section>

      {/* Day 1 - Сайн байна уу Найрамдал */}
      <section className="relative overflow-hidden bg-primary-800 py-16 sm:py-24">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/15 blur-[120px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-warm-300 backdrop-blur-sm mb-4">
              <span>🏕️</span> Амралтын эхний өдөр
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-2">Сайн байна уу Найрамдал</h2>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-warm-500 to-secondary-500" />
          </div>

          {/* Их үдийн */}
          <div className="mb-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-warm-500 to-secondary-500 flex items-center justify-center text-white font-bold">⏰</div>
              <div>
                <h3 className="text-xl font-bold text-white">Их үдийн хөтөлбөр</h3>
                <p className="text-sm text-slate-400">10:00–12:30</p>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 gap-6">
              {day1Bigday.map((item, idx) => (
                <div key={idx} className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 hover:bg-white/[0.08] transition-colors">
                  <div className="text-xs font-bold text-warm-400 uppercase tracking-wider mb-3">{item.age}</div>
                  <div className="space-y-3 mb-4">
                    <div>
                      <p className="text-xs font-semibold text-slate-500 mb-1">❄️ Өвөл</p>
                      <ul className="space-y-1">
                        {item.winter.map((w, i) => <li key={i} className="text-sm text-slate-300 leading-relaxed">• {w}</li>)}
                      </ul>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-500 mb-1">🌸🍁 Хавар-Намар</p>
                      <ul className="space-y-1">
                        {item.spring.map((s, i) => <li key={i} className="text-sm text-slate-300 leading-relaxed">• {s}</li>)}
                      </ul>
                    </div>
                  </div>
                  <p className="text-xs text-primary-300 italic border-t border-white/10 pt-3">🎯 {item.goal}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Бага үдийн */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-warm-500 to-secondary-500 flex items-center justify-center text-white font-bold">⏰</div>
              <div>
                <h3 className="text-xl font-bold text-white">Бага үдийн хөтөлбөр</h3>
                <p className="text-sm text-slate-400">17:00–18:30</p>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 gap-6">
              {day1Smallday.map((item, idx) => (
                <div key={idx} className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 hover:bg-white/[0.08] transition-colors">
                  <div className="text-xs font-bold text-warm-400 uppercase tracking-wider mb-3">{item.age}</div>
                  <div className="space-y-3 mb-4">
                    <div>
                      <p className="text-xs font-semibold text-slate-500 mb-1">❄️ Өвөл</p>
                      <ul className="space-y-1">
                        {item.winter.map((w, i) => <li key={i} className="text-sm text-slate-300 leading-relaxed">• {w}</li>)}
                      </ul>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-slate-500 mb-1">🌸🍁 Хавар-Намар</p>
                      <ul className="space-y-1">
                        {item.spring.map((s, i) => <li key={i} className="text-sm text-slate-300 leading-relaxed">• {s}</li>)}
                      </ul>
                    </div>
                  </div>
                  <p className="text-xs text-primary-300 italic border-t border-white/10 pt-3">🎯 {item.goal}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Project Programs */}
      <section className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-200/50 mb-4">
              <span>🎨</span> Төсөлт хөтөлбөрүүд
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4">
              Амралтын хугацаанд 3 өдөр, нийт 9 цагийн хугацаанд хамрагдах төсөлт хөтөлбөрүүд
            </h2>
            <p className="text-neutral-600 max-w-3xl mx-auto leading-relaxed">
              ОУХНЦ-ын хөтөлбөрийн санд байгаа төсөлт хөтөлбөрүүд зохион байгуулагдана. Амрагчид өөрийн сонирхсон хөтөлбөрт нэг удаа 150 минутаар 3 удаа хамрагдаж тодорхой ур чадвар эзэмшинэ.
            </p>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500 mt-4" />
          </div>

          <div className="grid lg:grid-cols-3 gap-6">
            {projectPrograms.map((group, idx) => {
              const accent = ['from-primary-500 to-primary-400', 'from-secondary-500 to-secondary-400', 'from-warm-500 to-warm-400'][idx];
              return (
                <div key={idx} className="rounded-2xl border border-neutral-200 overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                  <div className={`bg-gradient-to-r ${accent} px-6 py-4`}>
                    <h3 className="text-lg font-bold text-white">{group.age}</h3>
                  </div>
                  <ul className="p-6 space-y-3">
                    {group.items.map((item, i) => (
                      <li key={i} className="flex gap-3 text-sm text-neutral-700 leading-relaxed">
                        <svg className="w-5 h-5 flex-shrink-0 text-primary-600 mt-0.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          <div className="mt-8 max-w-3xl mx-auto p-5 rounded-2xl bg-primary-50 border-l-4 border-primary-500">
            <p className="text-sm text-primary-900 font-medium leading-relaxed">
              <strong>Үр дүн:</strong> Бүтээлч байдлыг нэмэгдүүлэх, шинэ мэдлэг ур чадвар эзэмшүүлэх, өөрийгөө нээхэд нь дэмжлэг үзүүлэх.
            </p>
          </div>
        </div>
      </section>

      {/* Entertainment Programs */}
      <section className="relative overflow-hidden bg-primary-800 py-16 sm:py-24">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-secondary-500/15 blur-[120px]" />
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="sparse" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-secondary-300 backdrop-blur-sm mb-4">
              <span>🎮</span> Хөгжөөнт хөтөлбөрүүд
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Амралтын хугацаанд явагдах хөгжөөнт хөтөлбөрүүд
            </h2>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-secondary-500 to-warm-500" />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {entertainmentPrograms.map((p, idx) => (
              <div key={idx} className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 hover:bg-white/[0.08] transition-colors">
                <h3 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
                  <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-secondary-500 to-warm-500 flex items-center justify-center text-sm">{idx + 1}</span>
                  {p.title}
                </h3>
                <p className="text-sm text-slate-300 leading-relaxed mb-4">{p.desc}</p>
                <div className="border-t border-white/10 pt-3">
                  <p className="text-xs text-secondary-300 italic">🎯 {p.goal}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Evening Programs */}
      <section className="bg-white py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 rounded-full bg-warm-50 px-4 py-1.5 text-sm font-semibold text-warm-700 ring-1 ring-warm-200/50 mb-4">
              <span>🌙</span> Оройн хөтөлбөр
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-2">Оройн хөтөлбөрүүд</h2>
            <p className="text-neutral-500">20:00–21:30 цагуудад зохион байгуулагдана</p>
            <div className="mx-auto h-1 w-24 rounded-full bg-gradient-to-r from-warm-500 to-primary-500 mt-4" />
          </div>

          <div className="grid lg:grid-cols-3 gap-6">
            {eveningPrograms.map((group, idx) => {
              const accent = ['from-warm-500 to-warm-400', 'from-secondary-500 to-secondary-400', 'from-primary-500 to-primary-400'][idx];
              return (
                <div key={idx} className="rounded-2xl border border-neutral-200 overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
                  <div className={`bg-gradient-to-r ${accent} px-6 py-4 flex items-center justify-between`}>
                    <h3 className="text-lg font-bold text-white">{group.age}</h3>
                    <span className="text-xs font-semibold text-white bg-white/20 px-2.5 py-1 rounded-full">{group.goal}</span>
                  </div>
                  <ul className="p-6 space-y-2.5">
                    {group.items.map((item, i) => (
                      <li key={i} className="flex gap-2.5 text-sm text-neutral-700 leading-relaxed">
                        <span className="text-warm-500 flex-shrink-0">★</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer Note */}
      <section className="bg-primary-50 py-12">
        <div className="mx-auto max-w-3xl px-6 text-center">
          <p className="text-sm text-primary-900 font-semibold uppercase tracking-wider">
            ОУХНЦ-ын Арга зүйн баг
          </p>
        </div>
      </section>
    </>
  );
};

export default SevenDayProgram;
